import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminNotificationsService } from '../services/adminNotifications.service';

export function useAdminNotifications(unreadOnly = false) {
  return useQuery({
    queryKey: ['admin', 'notifications', unreadOnly],
    queryFn: () => adminNotificationsService.list(unreadOnly),
    refetchInterval: 60_000,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => adminNotificationsService.markRead(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'notifications'] }),
  });
}
